// extracted by mini-css-extract-plugin
module.exports = {"errorIcon":"ErrorIcon__errorIcon___1ALYu","circleFill":"ErrorIcon__circleFill___1nH8W","symbolFill":"ErrorIcon__symbolFill___p__Je","dark":"ErrorIcon__dark___1IaOW"};